/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const lprCountIncrement = /* GraphQL */ `
  mutation LprCountIncrement($input: LPRCountChangeInput!) {
    LPRCountIncrement(input: $input) {
      id
      tenant
      name
      description
      count
      createdAt
      updatedAt
    }
  }
`;
export const lprCountDecrement = /* GraphQL */ `
  mutation LprCountDecrement($input: LPRCountChangeInput!) {
    LPRCountDecrement(input: $input) {
      id
      tenant
      name
      description
      count
      createdAt
      updatedAt
    }
  }
`;
export const createSite = /* GraphQL */ `
  mutation CreateSite(
    $input: CreateSiteInput!
    $condition: ModelSiteConditionInput
  ) {
    createSite(input: $input, condition: $condition) {
      tenant
      id
      label
      description
      lprcameras {
        items {
          tenant
          id
          siteID
          createdAt
          label
          latitude
          longitude
          installLatitude
          installLongitude
          macAddress
          serialNumber
          provision
          batteryPowered
          otherConfig
          description
          swVersion
          hwVersion
          lprLicenseKey
          lprLicenseToken
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateSite = /* GraphQL */ `
  mutation UpdateSite(
    $input: UpdateSiteInput!
    $condition: ModelSiteConditionInput
  ) {
    updateSite(input: $input, condition: $condition) {
      tenant
      id
      label
      description
      lprcameras {
        items {
          tenant
          id
          siteID
          createdAt
          label
          latitude
          longitude
          installLatitude
          installLongitude
          macAddress
          serialNumber
          provision
          batteryPowered
          otherConfig
          description
          swVersion
          hwVersion
          lprLicenseKey
          lprLicenseToken
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteSite = /* GraphQL */ `
  mutation DeleteSite(
    $input: DeleteSiteInput!
    $condition: ModelSiteConditionInput
  ) {
    deleteSite(input: $input, condition: $condition) {
      tenant
      id
      label
      description
      lprcameras {
        items {
          tenant
          id
          siteID
          createdAt
          label
          latitude
          longitude
          installLatitude
          installLongitude
          macAddress
          serialNumber
          provision
          batteryPowered
          otherConfig
          description
          swVersion
          hwVersion
          lprLicenseKey
          lprLicenseToken
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createLprCamera = /* GraphQL */ `
  mutation CreateLprCamera(
    $input: CreateLPRCameraInput!
    $condition: ModelLPRCameraConditionInput
  ) {
    createLPRCamera(input: $input, condition: $condition) {
      tenant
      id
      siteID
      createdAt
      site {
        tenant
        id
        label
        description
        lprcameras {
          nextToken
        }
        createdAt
        updatedAt
      }
      label
      latitude
      longitude
      installLatitude
      installLongitude
      macAddress
      serialNumber
      provision
      batteryPowered
      battery {
        totalVoltage
        totalCurrent
        batteryHighestTemp
        mosTemp
        soc
        soh
        chargeTimes
      }
      otherConfig
      file {
        bucket
        key
        region
      }
      description
      swVersion
      hwVersion
      lprLicenseKey
      lprLicenseToken
      lprevents {
        items {
          tenant
          id
          lprcameraID
          timestamp
          plate
          createdAt
          make
          model
          color
          year
          state
          style
          recognitionConfidence
          detectionConfidence
          countryConfidence
          colorConfidence
          mmyConfidence
          styleConfidence
          exif
          imageUuid
          tagged
          eventFlag
          coordinates
          carCoordinates
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const updateLprCamera = /* GraphQL */ `
  mutation UpdateLprCamera(
    $input: UpdateLPRCameraInput!
    $condition: ModelLPRCameraConditionInput
  ) {
    updateLPRCamera(input: $input, condition: $condition) {
      tenant
      id
      siteID
      createdAt
      site {
        tenant
        id
        label
        description
        lprcameras {
          nextToken
        }
        createdAt
        updatedAt
      }
      label
      latitude
      longitude
      installLatitude
      installLongitude
      macAddress
      serialNumber
      provision
      batteryPowered
      battery {
        totalVoltage
        totalCurrent
        batteryHighestTemp
        mosTemp
        soc
        soh
        chargeTimes
      }
      otherConfig
      file {
        bucket
        key
        region
      }
      description
      swVersion
      hwVersion
      lprLicenseKey
      lprLicenseToken
      lprevents {
        items {
          tenant
          id
          lprcameraID
          timestamp
          plate
          createdAt
          make
          model
          color
          year
          state
          style
          recognitionConfidence
          detectionConfidence
          countryConfidence
          colorConfidence
          mmyConfidence
          styleConfidence
          exif
          imageUuid
          tagged
          eventFlag
          coordinates
          carCoordinates
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const deleteLprCamera = /* GraphQL */ `
  mutation DeleteLprCamera(
    $input: DeleteLPRCameraInput!
    $condition: ModelLPRCameraConditionInput
  ) {
    deleteLPRCamera(input: $input, condition: $condition) {
      tenant
      id
      siteID
      createdAt
      site {
        tenant
        id
        label
        description
        lprcameras {
          nextToken
        }
        createdAt
        updatedAt
      }
      label
      latitude
      longitude
      installLatitude
      installLongitude
      macAddress
      serialNumber
      provision
      batteryPowered
      battery {
        totalVoltage
        totalCurrent
        batteryHighestTemp
        mosTemp
        soc
        soh
        chargeTimes
      }
      otherConfig
      file {
        bucket
        key
        region
      }
      description
      swVersion
      hwVersion
      lprLicenseKey
      lprLicenseToken
      lprevents {
        items {
          tenant
          id
          lprcameraID
          timestamp
          plate
          createdAt
          make
          model
          color
          year
          state
          style
          recognitionConfidence
          detectionConfidence
          countryConfidence
          colorConfidence
          mmyConfidence
          styleConfidence
          exif
          imageUuid
          tagged
          eventFlag
          coordinates
          carCoordinates
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const createLprEvents = /* GraphQL */ `
  mutation CreateLprEvents(
    $input: CreateLPREventsInput!
    $condition: ModelLPREventsConditionInput
  ) {
    createLPREvents(input: $input, condition: $condition) {
      tenant
      id
      lprcameraID
      lprcamera {
        tenant
        id
        siteID
        createdAt
        site {
          tenant
          id
          label
          description
          createdAt
          updatedAt
        }
        label
        latitude
        longitude
        installLatitude
        installLongitude
        macAddress
        serialNumber
        provision
        batteryPowered
        battery {
          totalVoltage
          totalCurrent
          batteryHighestTemp
          mosTemp
          soc
          soh
          chargeTimes
        }
        otherConfig
        file {
          bucket
          key
          region
        }
        description
        swVersion
        hwVersion
        lprLicenseKey
        lprLicenseToken
        lprevents {
          nextToken
        }
        updatedAt
      }
      timestamp
      plate
      createdAt
      make
      model
      color
      year
      state
      style
      recognitionConfidence
      detectionConfidence
      countryConfidence
      colorConfidence
      mmyConfidence
      styleConfidence
      exif
      imageUuid
      tagged
      eventFlag
      coordinates
      carCoordinates
      file {
        bucket
        key
        region
      }
      updatedAt
    }
  }
`;
export const updateLprEvents = /* GraphQL */ `
  mutation UpdateLprEvents(
    $input: UpdateLPREventsInput!
    $condition: ModelLPREventsConditionInput
  ) {
    updateLPREvents(input: $input, condition: $condition) {
      tenant
      id
      lprcameraID
      lprcamera {
        tenant
        id
        siteID
        createdAt
        site {
          tenant
          id
          label
          description
          createdAt
          updatedAt
        }
        label
        latitude
        longitude
        installLatitude
        installLongitude
        macAddress
        serialNumber
        provision
        batteryPowered
        battery {
          totalVoltage
          totalCurrent
          batteryHighestTemp
          mosTemp
          soc
          soh
          chargeTimes
        }
        otherConfig
        file {
          bucket
          key
          region
        }
        description
        swVersion
        hwVersion
        lprLicenseKey
        lprLicenseToken
        lprevents {
          nextToken
        }
        updatedAt
      }
      timestamp
      plate
      createdAt
      make
      model
      color
      year
      state
      style
      recognitionConfidence
      detectionConfidence
      countryConfidence
      colorConfidence
      mmyConfidence
      styleConfidence
      exif
      imageUuid
      tagged
      eventFlag
      coordinates
      carCoordinates
      file {
        bucket
        key
        region
      }
      updatedAt
    }
  }
`;
export const deleteLprEvents = /* GraphQL */ `
  mutation DeleteLprEvents(
    $input: DeleteLPREventsInput!
    $condition: ModelLPREventsConditionInput
  ) {
    deleteLPREvents(input: $input, condition: $condition) {
      tenant
      id
      lprcameraID
      lprcamera {
        tenant
        id
        siteID
        createdAt
        site {
          tenant
          id
          label
          description
          createdAt
          updatedAt
        }
        label
        latitude
        longitude
        installLatitude
        installLongitude
        macAddress
        serialNumber
        provision
        batteryPowered
        battery {
          totalVoltage
          totalCurrent
          batteryHighestTemp
          mosTemp
          soc
          soh
          chargeTimes
        }
        otherConfig
        file {
          bucket
          key
          region
        }
        description
        swVersion
        hwVersion
        lprLicenseKey
        lprLicenseToken
        lprevents {
          nextToken
        }
        updatedAt
      }
      timestamp
      plate
      createdAt
      make
      model
      color
      year
      state
      style
      recognitionConfidence
      detectionConfidence
      countryConfidence
      colorConfidence
      mmyConfidence
      styleConfidence
      exif
      imageUuid
      tagged
      eventFlag
      coordinates
      carCoordinates
      file {
        bucket
        key
        region
      }
      updatedAt
    }
  }
`;
export const createPicEvents = /* GraphQL */ `
  mutation CreatePicEvents(
    $input: CreatePicEventsInput!
    $condition: ModelPicEventsConditionInput
  ) {
    createPicEvents(input: $input, condition: $condition) {
      tenant
      id
      lprcameraID
      lprcamera {
        tenant
        id
        siteID
        createdAt
        site {
          tenant
          id
          label
          description
          createdAt
          updatedAt
        }
        label
        latitude
        longitude
        installLatitude
        installLongitude
        macAddress
        serialNumber
        provision
        batteryPowered
        battery {
          totalVoltage
          totalCurrent
          batteryHighestTemp
          mosTemp
          soc
          soh
          chargeTimes
        }
        otherConfig
        file {
          bucket
          key
          region
        }
        description
        swVersion
        hwVersion
        lprLicenseKey
        lprLicenseToken
        lprevents {
          nextToken
        }
        updatedAt
      }
      timestamp
      createdAt
      exif
      imageUuid
      file {
        bucket
        key
        region
      }
      updatedAt
    }
  }
`;
export const updatePicEvents = /* GraphQL */ `
  mutation UpdatePicEvents(
    $input: UpdatePicEventsInput!
    $condition: ModelPicEventsConditionInput
  ) {
    updatePicEvents(input: $input, condition: $condition) {
      tenant
      id
      lprcameraID
      lprcamera {
        tenant
        id
        siteID
        createdAt
        site {
          tenant
          id
          label
          description
          createdAt
          updatedAt
        }
        label
        latitude
        longitude
        installLatitude
        installLongitude
        macAddress
        serialNumber
        provision
        batteryPowered
        battery {
          totalVoltage
          totalCurrent
          batteryHighestTemp
          mosTemp
          soc
          soh
          chargeTimes
        }
        otherConfig
        file {
          bucket
          key
          region
        }
        description
        swVersion
        hwVersion
        lprLicenseKey
        lprLicenseToken
        lprevents {
          nextToken
        }
        updatedAt
      }
      timestamp
      createdAt
      exif
      imageUuid
      file {
        bucket
        key
        region
      }
      updatedAt
    }
  }
`;
export const deletePicEvents = /* GraphQL */ `
  mutation DeletePicEvents(
    $input: DeletePicEventsInput!
    $condition: ModelPicEventsConditionInput
  ) {
    deletePicEvents(input: $input, condition: $condition) {
      tenant
      id
      lprcameraID
      lprcamera {
        tenant
        id
        siteID
        createdAt
        site {
          tenant
          id
          label
          description
          createdAt
          updatedAt
        }
        label
        latitude
        longitude
        installLatitude
        installLongitude
        macAddress
        serialNumber
        provision
        batteryPowered
        battery {
          totalVoltage
          totalCurrent
          batteryHighestTemp
          mosTemp
          soc
          soh
          chargeTimes
        }
        otherConfig
        file {
          bucket
          key
          region
        }
        description
        swVersion
        hwVersion
        lprLicenseKey
        lprLicenseToken
        lprevents {
          nextToken
        }
        updatedAt
      }
      timestamp
      createdAt
      exif
      imageUuid
      file {
        bucket
        key
        region
      }
      updatedAt
    }
  }
`;
export const createAllowList = /* GraphQL */ `
  mutation CreateAllowList(
    $input: CreateAllowListInput!
    $condition: ModelAllowListConditionInput
  ) {
    createAllowList(input: $input, condition: $condition) {
      tenant
      id
      plate
      description
      createdAt
      updatedAt
    }
  }
`;
export const updateAllowList = /* GraphQL */ `
  mutation UpdateAllowList(
    $input: UpdateAllowListInput!
    $condition: ModelAllowListConditionInput
  ) {
    updateAllowList(input: $input, condition: $condition) {
      tenant
      id
      plate
      description
      createdAt
      updatedAt
    }
  }
`;
export const deleteAllowList = /* GraphQL */ `
  mutation DeleteAllowList(
    $input: DeleteAllowListInput!
    $condition: ModelAllowListConditionInput
  ) {
    deleteAllowList(input: $input, condition: $condition) {
      tenant
      id
      plate
      description
      createdAt
      updatedAt
    }
  }
`;
export const createDenyList = /* GraphQL */ `
  mutation CreateDenyList(
    $input: CreateDenyListInput!
    $condition: ModelDenyListConditionInput
  ) {
    createDenyList(input: $input, condition: $condition) {
      tenant
      id
      plate
      description
      createdAt
      updatedAt
    }
  }
`;
export const updateDenyList = /* GraphQL */ `
  mutation UpdateDenyList(
    $input: UpdateDenyListInput!
    $condition: ModelDenyListConditionInput
  ) {
    updateDenyList(input: $input, condition: $condition) {
      tenant
      id
      plate
      description
      createdAt
      updatedAt
    }
  }
`;
export const deleteDenyList = /* GraphQL */ `
  mutation DeleteDenyList(
    $input: DeleteDenyListInput!
    $condition: ModelDenyListConditionInput
  ) {
    deleteDenyList(input: $input, condition: $condition) {
      tenant
      id
      plate
      description
      createdAt
      updatedAt
    }
  }
`;
export const createLprAuditLog = /* GraphQL */ `
  mutation CreateLprAuditLog(
    $input: CreateLPRAuditLogInput!
    $condition: ModelLPRAuditLogConditionInput
  ) {
    createLPRAuditLog(input: $input, condition: $condition) {
      tenant
      id
      user
      log
      createdAt
      updatedAt
    }
  }
`;
export const updateLprAuditLog = /* GraphQL */ `
  mutation UpdateLprAuditLog(
    $input: UpdateLPRAuditLogInput!
    $condition: ModelLPRAuditLogConditionInput
  ) {
    updateLPRAuditLog(input: $input, condition: $condition) {
      tenant
      id
      user
      log
      createdAt
      updatedAt
    }
  }
`;
export const deleteLprAuditLog = /* GraphQL */ `
  mutation DeleteLprAuditLog(
    $input: DeleteLPRAuditLogInput!
    $condition: ModelLPRAuditLogConditionInput
  ) {
    deleteLPRAuditLog(input: $input, condition: $condition) {
      tenant
      id
      user
      log
      createdAt
      updatedAt
    }
  }
`;
export const createLprCount = /* GraphQL */ `
  mutation CreateLprCount(
    $input: CreateLPRCountInput!
    $condition: ModelLPRCountConditionInput
  ) {
    createLPRCount(input: $input, condition: $condition) {
      id
      tenant
      name
      description
      count
      createdAt
      updatedAt
    }
  }
`;
export const updateLprCount = /* GraphQL */ `
  mutation UpdateLprCount(
    $input: UpdateLPRCountInput!
    $condition: ModelLPRCountConditionInput
  ) {
    updateLPRCount(input: $input, condition: $condition) {
      id
      tenant
      name
      description
      count
      createdAt
      updatedAt
    }
  }
`;
export const deleteLprCount = /* GraphQL */ `
  mutation DeleteLprCount(
    $input: DeleteLPRCountInput!
    $condition: ModelLPRCountConditionInput
  ) {
    deleteLPRCount(input: $input, condition: $condition) {
      id
      tenant
      name
      description
      count
      createdAt
      updatedAt
    }
  }
`;
